import React from 'react'
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleReactFlow =()=>{
      navigate(`/messages`)
 }
  return (
    <div>
       <h1>hello from Dashboard</h1>
       <button  onClick={handleReactFlow} > message</button>
    </div>
  )
}

export default Dashboard
